import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=1c17a2c2&"
import script from "./ReadMore.vue?vue&type=script&lang=ts&"
export * from "./ReadMore.vue?vue&type=script&lang=ts&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports